import LieuFormController from './lieu.form.controller';

export default {
    template: require('./lieu.form.html'),
    controller: LieuFormController
};
